import OpenRequestsInbox from './OpenRequestsInbox';

const UserInbox = () => (
  <OpenRequestsInbox
    title="DCR Inbox"
  />
);

export default UserInbox;
